import React from "react";
import Image from "next/image";
import Typography from "../common/Typography/Typography";
import ImageModal from "./ImageModal/ImageModal";

import styles from "./ImageGallery.module.css";

interface Image {
    src: string;
    label?: string;
    id: string | number;
}

export interface Props {
    images: Image[];
    imageTile?: boolean;
    limit?: number;
}

const ImageGallery = ({ images, limit = 999, imageTile = false }: Props) => (
    <div className={!imageTile ? styles.ImageGrid : styles.ImageGridTile}>

        {images.slice(0, limit).map((image, index) => (
            <ImageModal key={image.label} src={image.src} label={image.label || `Image ${index}`}>
                <div className={imageTile ? "" : "border border-pine-800 rounded cursor-pointer"}>
                    <div className={!imageTile ? styles.ImageThumbnail : styles.ImageThumbnailTile}>
                        <Image
                            src={image.src}
                            fill
                            className={`object-cover ${imageTile ? "rounded-md" : "rounded-t-md"}`}
                            alt={image.label || `Image ${index}`}
                        />
                    </div>

                    {!imageTile ? (
                        <div className="p-1">
                            <Typography as="p" variant="meta" color="midnight">
                                {image.label}
                            </Typography>
                        </div>
                    ) : null}
                </div>
            </ImageModal>
        ))}
        {limit && images.length > limit ? (
            <div className={styles.ImageThumbnailSuffix}>
                <Typography variant="meta" color="pine">
                    +{images.length - limit}
                </Typography>
            </div>
        ) : null}
    </div>
);

export default ImageGallery;
